import Chip from '@mui/material/Chip';
import { plural } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

export interface ErrorLabelProps {
  errorCount?: number;
}

export const ErrorLabel = ({ errorCount }: ErrorLabelProps) => {
  return (
    <Chip
      color="error"
      size="small"
      label={
        errorCount ? (
          plural(errorCount, { one: '# Error', other: '# Errors' })
        ) : (
          <Trans>Error</Trans>
        )
      }
    />
  );
};
